module.exports = "/_next/static/images/6c6205a08175f120edf81304ab66d396-slide-1-large.png.webp";